{
  "version": 1,
  "asset_id": "cbe63e1b-dde7-4e1f-abe3-b4841070fbd7",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/cbe63e1b-dde7-4e1f-abe3-b4841070fbd7/buratti-truck.jpg",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/cbe63e1b-dde7-4e1f-abe3-b4841070fbd7/buratti-truck.jpg",
  "original_filename": "buratti-truck.jpg",
  "size": 103432,
  "content_type": "image/jpeg",
  "created_at": "2026-10-08T11:34:06Z"
}
